firebird.factory('videoConnectService', [
    '$rootScope',
    '$timeout',
    '$window',
    'logService',
    'attendeeService',
    'connectivityService',
    'socketService',
    'attendeeListService',
    'helperService',
    'configService',
    'meetingService',
    'analyticsWrapperService',
    'videoFilterService',
    'videoGlobalService',
    'avDeviceService',
    'localizationService',
    'executionEnvironmentEnum',
    function (
        $rootScope,
        $timeout,
        $window,
        logService,
        attendeeService,
        connectivityService,
        socketService,
        attendeeListService,
        helperService,
        configService,
        meetingService,
        analyticsWrapperService,
        videoFilterService,
        videoGlobalService,
        avDeviceService,
        localizationService,
        executionEnvironmentEnum
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoConnectService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.initConnect = initConnect;

            // Janus instance
            self.janus = null;

            // unique id used by janus to co-related different plugin handles of the same user
            self.instanceId = (helperService.isElectron() ? 'El' : 'Wb') + $window.Janus.randomString(10);
            self.opaqueId =
                'web:' +
                helperService.getEnvironment() +
                ':' +
                meetingService.getMeetingCode() +
                ':' +
                attendeeService.getAttendantId() +
                ':' +
                self.instanceId;

            // whether to use new combined plugin, or separate SIP and video room plugins.
            self.newplugin = true;

            // Janus service must be reachable over wss or https
            self.server = null;

            // Janus videoroom id (integer)
            self.myroom = 0;

            // to allow timeout for reclaim (reconnect), and to ignore reclaim success if already timeout.
            self.ignoreMediaReconnectResult = false;
            self.mediaReconnectTimer = null;
            self.cancelMediaReconnectTimer = cancelMediaReconnectTimer;

            self.showConnectedOverlayOnSipAccept = false;
            self.showConnectingOverlay = showConnectingOverlay;
            self.showConnectedOverlay = showConnectedOverlay;

            self.addPinToRequest = addPinToRequest;

            self.getJanusConnectionState = getJanusConnectionState;

            self.detachPlugin = detachPlugin;

            self.conferenceLeft = false;
            self.joinConference = joinConference;
            self.leaveConference = leaveConference;
            self.leaveConferenceAlt = leaveConferenceAlt;
            self.destroyJanus = destroyJanus;
            self.onFSConnectionComplete = onFSConnectionComplete;
            self.setPhoneOnlyState = setPhoneOnlyState;
            self.shouldRejoinAfterError = shouldRejoinAfterError;
            self.shouldReattachPluginAfterError = shouldReattachPluginAfterError;
            self.calculateTimeoutLength = calculateTimeoutLength;
            self.retryWithExponentialBackoffAndLimit = retryWithExponentialBackoffAndLimit;

            self.updateLayoutAfterReconnect = false;

            self.iceTransportPolicy = 'all';
            // if positive number, then select TURN TCP 443 always or after that many-1 disconnects detected.
            self.iceTransportOnTCP = 0;
            self.iceDisconnectedCount = 0; // used together with iceTransportOnTCP if set. do not reset on call leave.
            self.iceDisconnectedMaxDuration = 5 * 60000; // ignore disconnects if more than 5 minutes ago.

            self.getIceTransportPolicy = getIceTransportPolicy;
            self.getIceServers = getIceServers;

            self.isAttendeeVideoMuted = isAttendeeVideoMuted;
            self.syncAttendeeListVideoMuteInternal = syncAttendeeListVideoMuteInternal;
            self.syncAttendeeListVideoMuteStates = syncAttendeeListVideoMuteStates;

            self.sendRestartVideo = false; // is set when createOfferForVideo wants to send restart-video-play on success.
            self.sendRestartVideoPlay = sendRestartVideoPlay;

            self.onAttendeeListUpdated = onAttendeeListUpdated;

            $scope.$on('attendee-list-updated', onAttendeeListUpdated);
            $scope.$on('fs-connection-complete', onFSConnectionComplete);

            // attendee message is used for slowlink event in some cases.
            $scope.$on('attendee-message', onAttendeeMessage);
        }

        // update state from config
        function initConnect() {
            self.iceTransportPolicy = 'all';
            if (configService.getClientValue('iceTransport') === 'relay') {
                logService.log("videoroomCtrl using iceTransportPolicy 'relay'");
                self.iceTransportPolicy = 'relay';
            }

            // can be modified by URL param or user pair. format "1" or "5,300000". First is iceTransportOnTCP and second is iceDisconnectedMaxDuration.
            var iceTransportOnTCP = configService.getValue('iceTransportOnTCP') || '6';
            if (iceTransportOnTCP == 'true') {
                // fallback for convenience.
                iceTransportOnTCP = '1';
            } else if (iceTransportOnTCP == 'false') {
                iceTransportOnTCP = '0';
            }
            self.iceTransportOnTCP = parseInt(iceTransportOnTCP) || 0;
            if (self.iceTransportOnTCP) {
                var indexOther = (iceTransportOnTCP || '').indexOf(',');
                if (indexOther > 0) {
                    self.iceDisconnectedMaxDuration = parseInt(iceTransportOnTCP.split(',')[1]) || 5 * 60000;
                }
                logService.log(
                    'videoroomCtrl using iceTransportOnTCP ' +
                        self.iceTransportOnTCP +
                        ' iceDisconnectedMaxDuration=' +
                        self.iceDisconnectedMaxDuration
                );
            }
        }

        function showConnectingOverlay() {
            $rootScope.$broadcast('toggled-connect-overlay', {
                message: localizationService.translate('WEBINAR_STATUS_BAR.CONNECTING_TO_YOUR_MEETING'),
                showConnectOverlay: true
            });
        }

        // show a message that client is connected.
        function showConnectedOverlay() {
            $timeout(function () {
                $rootScope.$broadcast('toggled-connect-overlay', {
                    showConnectOverlay: false
                });
            }, 2000);

            $rootScope.$broadcast('toggled-connect-overlay', {
                message: localizationService.translate('WEBINAR_STATUS_BAR.CONNECTED'),
                showConnectOverlay: true
            });
        }

        function leaveConferenceAlt(type) {
            self.willSwitchDevice = false;
            avDeviceService.setIsMicrophoneDeviceSwitching(false);

            self.stopAllLocalTracks();

            var div = self.getVideoElement();
            if (div && div.length > 0) {
                div.attr('playing', false);
            }

            self.disconnectRetry += 1;

            self.destroyJanus(type);

            if (self.screenshareOwner) {
                self.setScreenDisplay(false);
                self.stopVideoPlay(self.screenshareOwner, true);
                // do not set this to null, as it will be used after connection establishes.

                // since original video elements are maintained, maxvideo may point to wrong video now.
                if (self.maxvideo && self.maxvideo.remoteFeed && self.maxvideo.remoteFeed.isScreen) {
                    self.setSpotlightVideo(null);
                }
            }

            for (var s in self.feeds) {
                // plugin handle is already detached. Do not remove video element, as new
                // reconnection will re-use the element.
                delete self.feeds[s];
            }

            self.stopQualityStats();
            self.networkCancelMoreStatsAfter();
            self.layoutPagePendingTimerStop();
            self.brokenMediaSource.prompted = false;

            // do not remove event listener on rejoin, as it gets called after init
            self.cleanupPauseVideoOnBgState(type == 'rejoin');
        }

        // from janustest.js

        // Create the janus handle, and when done, create the video publisher. When the handle is
        // destroyed, stop all the local streams, and remove the local view video element.
        function joinConference() {
            logger.log('joinConference', 'videoroomCtrl - joinConference');

            if (self.conferenceLeft) {
                logger.log('joinConference', 'videoroomCtrl conferenceLeft true, returning from joinConference');
                return;
            }

            if (!$window.Janus.isWebrtcSupported()) {
                logger.error('joinConference', 'no WebRTC support');
                self.showAlert('No WebRTC support...');
                return;
            }
            analyticsWrapperService.eventTrack('Meeting - socket connection - starting', { sfuEvent: true });

            self.showConnectingOverlay();

            if (self.janus) {
                logger.warn('joinConference', 'join conference called while previous is pending or active');
                self.msgflowEvent('error:double-join', {
                    reason: 'joinConference called while previous is active or pending'
                });
                self.destroyJanus('double-join');
            }

            if (
                self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix ||
                self.VDIRef.getVdiType() === executionEnvironmentEnum.VMware
            ) {
                self.msgflowEvent('vdi-join');
            }

            self.janus = new $window.Janus({
                server: self.server,
                iceServers: self.getIceServers(),
                iceTransportPolicy: self.getIceTransportPolicy(), //if not provided, 'all' is used by default
                destroyOnUnload: false,
                trackDuration: self.networkState.media.trackDuration,
                trackCandidates: self.trackCandidates,
                success: function () {
                    logger.log('joinConference', 'Session successfully created', self.janus.getSessionId());

                    analyticsWrapperService.eventTrack('Meeting - socket connection - connected', { sfuEvent: true });
                    $rootScope.$broadcast('sfu-ws-connected');
                    var wasReconnecting = self.disconnectRetry > 0;
                    self.disconnectRetry = 0;
                    self.startVoiceCall();

                    if (self.screenshareOwner && self.screenshareOwner != self.attendantId) {
                        // add the screen share video play
                        self.startVideoPlay(self.screenshareOwner, true, true);
                        self.setScreenDisplay(true);
                    }
                    if (self.screenshareState == 'disconnected' && !self.screenshare) {
                        logger.log('joinConference', 'videoroomCtrl restarting screen share after reconnection');
                        self.startScreenShare();
                    }
                    if (wasReconnecting) {
                        // TODO: hacky way to trigger attendee-list-update for all others
                        // This is needed so that if only janus was reconnected, but node was not
                        // then others should still play the reconnected user's video.
                        socketService.send({
                            message: 'attendee-connectivity-updated',
                            data: {}
                        });
                    }

                    if (self.updateLayoutAfterReconnect) {
                        self.updateLayoutAfterReconnect = false;
                        self.updateVideosLayout();
                    }
                },
                error: function (error) {
                    logger.error('joinConference', 'Janus error callback', error);
                    analyticsWrapperService.eventTrack('Meeting - socket connection - error', { sfuEvent: true });

                    $rootScope.$broadcast('sfu-ws-disconnected', { retry: self.disconnectRetry });
                    connectivityService.setVertoConnected(false); //TODO: should be removed

                    const recreate = self.shouldRejoinAfterError(error);

                    if (!recreate && self.enableReclaim && self.disconnectRetry == 0) {
                        self.ignoreMediaReconnectResult = false;
                        self.cancelMediaReconnectTimer();

                        self.mediaReconnectTimer = $timeout(() => {
                            self.mediaReconnectTimer = null;
                            self.ignoreMediaReconnectResult = true;

                            logger.warn('joinConference', 'Session reclaim timed out, will rejoin');
                            self.msgflowEvent('reclaim:timeout');

                            self.prepareForRejoinConference();
                            self.rejoinConferenceAfter('reconnect timed out', 1000);
                        }, self.enableReclaimTimeout);

                        // first time attempt to reclaim the session.
                        $timeout(function () {
                            const oldJanus = self.janus;

                            self.janus.reconnect({
                                success: function () {
                                    if (self.ignoreMediaReconnectResult) {
                                        logger.log(
                                            'joinConference->error->janus.reconnect->success',
                                            'Session successfully reclaimed after timeout, ignored',
                                            self.janus.getSessionId()
                                        );

                                        return;
                                    }

                                    if (self.janus !== oldJanus) {
                                        logger.error(
                                            'joinConference->error->janus.reconnect->success',
                                            'Session reclaimed, but for different object',
                                            self.janus.getSessionId()
                                        );
                                        return;
                                    }

                                    logger.log(
                                        'joinConference->error->janus.reconnect->success',
                                        'Session successfully reclaimed',
                                        self.janus.getSessionId()
                                    );
                                    self.msgflowEvent('reclaim:success');

                                    self.cancelMediaReconnectTimer();

                                    $rootScope.$broadcast('sfu-ws-connected');
                                    connectivityService.setVertoConnected(true); //TODO: should be removed

                                    // other attendees can start screenshare while reconnecting, handle it
                                    if (self.screenshareOwner && self.screenshareOwner != self.attendantId) {
                                        const screenShareId = self.getScreenshareIdFromAttendantId(
                                            self.screenshareOwner
                                        );

                                        if (self.feeds[screenShareId] === undefined) {
                                            // add the screen share video play
                                            self.msgflowEvent('play-restart:screen', {
                                                reason: 'reclaim',
                                                id: screenShareId
                                            });
                                            self.startVideoPlay(self.screenshareOwner, true, true);
                                        }
                                    }

                                    // other attendees can turn on webcam while reconnecting, handle it
                                    self.syncAttendeeListVideoMuteStates();
                                },
                                error: function (err) {
                                    if (self.ignoreMediaReconnectResult) {
                                        logger.log(
                                            'joinConference->error->janus.reconnect->error',
                                            'Failed to reclaim after timeout, ignored'
                                        );

                                        return;
                                    }

                                    if (self.janus !== oldJanus) {
                                        logger.warn(
                                            'joinConference->error->janus.reconnect->error',
                                            'Failed to reclaim, but for different object'
                                        );
                                        return;
                                    }

                                    logger.error('joinConference', 'Session failed to reclaim, will rejoin', err);
                                    self.msgflowEvent('reclaim:error');

                                    self.cancelMediaReconnectTimer();

                                    self.prepareForRejoinConference();
                                    self.rejoinConferenceAfter('reconnect failed', 1000);
                                }
                            });
                        }, 1000);
                    } else {
                        self.retryWithExponentialBackoffAndLimit({
                            count: self.disconnectRetry,
                            limit: self.disconnectMaxRetries,
                            success: timeoutLength => {
                                const reason = (recreate && error?.reason) || 'Failed to reclaim';
                                logger.log(
                                    'joinConference',
                                    `Janus error callback: ${reason}, will retry in ${timeoutLength} ms`
                                );
                                // disconnectRetry increased in leaveConferenceAlt function
                                self.prepareForRejoinConference();
                                self.rejoinConferenceAfter(reason, timeoutLength, undefined, recreate);
                            },
                            error: () => {
                                self.prepareForRejoinConference();
                                $rootScope.$broadcast('sfu-ws-gave-up');
                            }
                        });
                    }
                },
                coreError: function (error) {
                    if (self.rejoinConferenceTimer) {
                        logger.log(
                            'joinConference',
                            'Janus core error callback: will not retry because we are in the rejoining state',
                            error
                        );
                        return;
                    }

                    var recreate = self.shouldRejoinAfterError(error);
                    if (recreate) {
                        self.retryWithExponentialBackoffAndLimit({
                            count: self.disconnectRetry,
                            limit: self.disconnectMaxRetries,
                            success: timeoutLength => {
                                const reason = error?.reason || 'core error';
                                logger.log(
                                    'joinConference',
                                    `Janus core error callback: ${reason}, will retry in ${timeoutLength} ms`
                                );
                                // disconnectRetry increased in leaveConferenceAlt function
                                self.prepareForRejoinConference();
                                self.rejoinConferenceAfter(reason, timeoutLength, undefined, true);
                            },
                            error: () => {
                                // decided not to do rejoin for core error when reach the retry limit
                            }
                        });
                    }
                },
                destroyed: function () {
                    analyticsWrapperService.eventTrack('Meeting - socket connection - disconnected', {
                        sfuEvent: true
                    });
                    // When destroyed, stop all the local streams, and remove local video element.
                    logger.log('joinConference', 'Janus destroyed');
                    self.stopAllLocalTracks();
                    self.removeVideoElement();
                },
                noGoodIceCandidates: function () {
                    self.msgflowEvent('no-candidates', {
                        iceTransportSwitchedToTCP: self.iceTransportSwitchedToTCP
                    });

                    if (!self.iceTransportSwitchedToTCP) {
                        self.iceTransportSwitchedToTCP = true;

                        logger.warn('joinConference', 'no good ice candidates, try to use TURN TCP 443');

                        self.iceTransportOnTCP = 1;
                        self.rejoinConferenceAfter('TCP 443', 0, false, true);

                        analyticsWrapperService.eventTrack('Meeting - fallback to TURN TCP 443 - no good candidates', {
                            sfuEvent: true
                        });
                    } else {
                        logger.warn('joinConference', 'no good ice candidates, TURN TCP 443 is already used');
                    }
                },
                duration: function (requestName, requestDuration) {
                    if (requestDuration > self.networkState.media.durationThreshold) {
                        logger.warn('The duration of the request to Janus is too long', requestName, requestDuration);

                        if (!self.checkConn.timer) {
                            self.checkConnectivity('janus delay', 0, function (result) {
                                // rejoin if check connectivity timed out
                                if (!result) {
                                    self.rejoinConferenceAfter('janus delay', 0, false, true);
                                }
                            });
                        }

                        if (!self.peerConnectionStatsTimer) {
                            const pcInfo = self.getPeerConnectionForStats();
                            if (pcInfo && !pcInfo.pc.statsAnalysisInProgress) {
                                pcInfo.pc.statsAnalysisInProgress = true;
                                self.analyzePeerConnectionStatsAndRejoinConferenceIfNeeded(pcInfo.pc, pcInfo.type, {
                                    skipCheckConnectivity: true
                                });
                            }
                        }
                    }
                }
            });
        }

        // Just destroy the Janus handle to close the conference from this end.
        function leaveConference() {
            logger.log('leaveConference', 'videoroomCtrl leave conference, destroy Janus');
            self.conferenceLeft = true;

            // cancel all timers that may be related to reconnects.

            self.cancelMediaReconnectTimer();
            self.cancelVideoRepublishTimer();
            self.cancelScreenRepublishTimer();
            self.cancelRestartSipCallTimer();
            self.cancelRestartScreenSipCallTimer();

            if (self.nodeReconnectTimer) {
                $timeout.cancel(self.nodeReconnectTimer);
                self.nodeReconnectTimer = null;
            }

            if (self.nodeReconnectJoinTimeout) {
                $timeout.cancel(self.nodeReconnectJoinTimeout);
                self.nodeReconnectJoinTimeout = null;
            }

            if (self.waitForConnectivityCheck) {
                self.waitForConnectivityCheck = false;
            }

            if (self.rejoinConferenceTimer) {
                $timeout.cancel(self.rejoinConferenceTimer);
                self.rejoinConferenceTimer = null;
            }

            self.networkCancelMoreStatsAfter();

            if (self.networkState.waitForRestore) {
                self.networkState.waitForRestore = false;
            }

            self.cancelPeerConnectionStats();

            if (self.kickConferenceTimer) {
                $timeout.cancel(self.kickConferenceTimer);
                self.kickConferenceTimer = null;
            }

            if ($window.navigator.connection) {
                $window.navigator.connection.onchange = null;
            }

            $window.removeEventListener('online', self.onNetworkStateChange);
            $window.removeEventListener('offline', self.onNetworkStateChange);

            if (self.layoutPopout) {
                self.onPopoutLeaveConf();
            }

            self.stopCheckConnectivity();

            self.updateLayoutAfterReconnect = false;
            self.destroyJanus('leave');

            if (self.showStatsDisplay) {
                self.toggleStatsDisplay();
            }

            connectivityService.setVertoConnected(false); //TODO: should be removed
            connectivityService.setFSMemberConnected(false);
            self.stopSpeedTest();
            self.stopSendStats();
            self.stopQualityStats();

            if (self.msgflow) {
                delete $window.Janus.msgflow;
                self.msgflow.close();
                self.msgflow = null;
            }

            videoFilterService.resetVideoFilter();
            self.videoOnScreenStop();
            self.stopFaceTrackStream();
            self.stopVideoCanvasStream();
            self.layoutPagePendingTimerStop();
            self.cleanupPauseVideoOnBgState();
        }

        function cancelMediaReconnectTimer() {
            if (self.mediaReconnectTimer) {
                $timeout.cancel(self.mediaReconnectTimer);
                self.mediaReconnectTimer = null;
            }
        }

        // depending on the type, destroy janus with different options.
        function destroyJanus(type) {
            logger.log('destroyJanus', `destroy janus (type=${type})`);

            self.iceRestartCancelAll();
            if (self.sipcall) {
                self.clearSipReconnectTimeout(self.sipcall);
            }
            if (self.screensipcall) {
                self.clearSipReconnectTimeout(self.screensipcall);
            }
            if (self.layoutPage) {
                self.onLayoutPageResetAll();
                if (self.layoutPageReuse.enabled) {
                    self.onLayoutPageSubscriberRemoveAll(); // remove all subscribers
                }
            }
            if (self.timerCheckRoomExists) {
                $timeout.cancel(self.timerCheckRoomExists);
                self.timerCheckRoomExists = null;
            }
            if (self.timerCheckRoomExistsScreen) {
                $timeout.cancel(self.timerCheckRoomExistsScreen);
                self.timerCheckRoomExistsScreen = null;
            }

            self.stopResyncAfterNoSuchFeedTimer();

            self.resetIceRestartState();
            //self.resetVideoStats();

            if (self.pendingSimulcastEncodings) {
                self.pendingSimulcastEncodings = null;
            }

            if (self.janus) {
                if (self.sipcall && !self.sipcall.detaching) {
                    self.detachPlugin(self.sipcall);
                    self.sipcall = null;
                }
                if (self.videoroom && !self.videoroom.detaching) {
                    // to avoid user id already exists error in some cases.
                    self.detachPlugin(self.videoroom);
                    self.videoroom = null;
                }
                if (self.screenshare && !self.screenshare.detaching) {
                    self.detachPlugin(self.screenshare);
                    self.screenshare = null;
                }
                if (self.screensipcall && !self.screensipcall.detaching) {
                    self.detachPlugin(self.screensipcall);
                    self.screensipcall = null;
                }
                var options = type == 'leave' ? { cleanupHandles: true } : { cleanupEverything: true };
                if (type == 'rejoin' || type == 'kicked') {
                    options.success = function () {
                        logService.log('videoroomCtrl destroyed previous janus handle type=' + type);
                    };
                }
                if (self.janus.destroy) {
                    self.janus.destroy(options);
                }
                self.janus = null;
            } else {
                logger.warn('destroyJanus', 'janus is not defined');
            }

            // all the plugin handles are cleared too. do not detach, as they are implicitly removed previously.
            self.screenshare = self.videoroom = self.screensipcall = self.sipcall = null;
        }

        function detachPlugin(plugin) {
            logger.log('detachPlugin', 'detach plugin', plugin.id);

            self.clearSipReconnectTimeout(plugin);
            plugin.detaching = true; // set state while it is detaching, so that oncleanup knows and does not call another function to stop plugin.
            plugin.detach({ noRequest: false });
            delete plugin.detaching; // reset the detaching state.
        }

        function getJanusConnectionState() {
            return self.janus && self.janus.isConnected() ? 'connected' : 'disconnected';
        }

        /**
         * @description
         *   Executes 'success' callback if retry logic limit is not reached.
         *   Executes 'error' callback if too many retries.
         *
         * @param {object} settings
         *   Numeric 'count' and 'limit' properties must be provided for retry logic.
         *   Must provide 'success' and 'error' callbacks.
         */
        function retryWithExponentialBackoffAndLimit(settings) {
            if (!settings || typeof settings !== 'object') {
                return;
            }

            if (!settings.success || typeof settings.success !== 'function') {
                return;
            }

            if (!settings.error || typeof settings.error !== 'function') {
                return;
            }

            if (!settings.count || typeof settings.count !== 'number' || settings.count < 0) {
                settings.count = 0;
            }

            if (!settings.limit || typeof settings.limit !== 'number' || settings.limit < 0) {
                settings.limit = 10;
            }

            if (settings.count < settings.limit) {
                const timeoutLength = self.calculateTimeoutLength(settings.count);
                settings.success(timeoutLength);
            } else {
                settings.error();
            }
        }

        function calculateTimeoutLength(attempt) {
            // use randomized exponential backoff with cut-off.
            const timeoutLength = attempt ? Math.min(60000, 1000 * Math.pow(2, attempt - 1)) : 0;
            return timeoutLength <= 8000 ? timeoutLength : timeoutLength - 4000 + Math.floor(8000 * Math.random(8000));
        }

        function shouldReattachPluginAfterError(error) {
            return error.code === 461; // JANUS_ERROR_PLUGIN_ATTACH
        }

        function shouldRejoinAfterError(error) {
            return (
                (!self.reclaimOnLostWebsocket &&
                    typeof error === 'string' &&
                    error.indexOf('Lost connection to the server') === 0) || // Janus socket closed (timeout)
                error.code === 404 || // JANUS_ERROR_NOT_FOUND
                error.code === 457 || // JANUS_ERROR_INVALID_REQUEST_PATH
                error.code === 458 || // JANUS_ERROR_SESSION_NOT_FOUND
                error.code === 468 || // JANUS_ERROR_SESSION_CONFLICT
                error.code === 471 || // JANUS_ERROR_WEBRTC_STATE
                error.code === 490 // JANUS_ERROR_UNKNOWN
            );
        }

        // When an attendee-message is received. This is currently used by video subscriber to inform
        // video publisher that server to subscriber had slow link event.
        function onAttendeeMessage(evt, msg) {
            if (msg.type == 'slowlink') {
                logService.log('videoroomCtrl attendee-message slowlink lost=' + msg.lost + ' bitrate=' + msg.bitrate);
                // this is when server to subscriber slow link happened.
                // Note: if simulcast was restricted, we are already in the lowest substream
                if (!attendeeService.getIsVideoMuted() && self.videoroom && !self.simulcastToggleState.restricted) {
                    // treat this as if the publisher to server slow link happened if bitrate.adjust is defined
                    // otherwise follow a parallel application logic to temporarily reduce bitrate.
                    if (self.bitrate.adjust && !self.bitrate.altmax) {
                        self.onSlowLink('video', true, msg.lost);
                    } else {
                        self.createAltVideoBitrateControl(!!msg.lost, (msg.bitrate || 0) * 1000, true);
                    }
                }
            } else if (msg.type == 'restart-video-play') {
                logService.log(
                    'videoroomCtrl attendee-message restart-video-play from=' + msg.from + ' screen=' + msg.screen
                );
                // publisher wants its stream to be re-subscribed, e.g., if codec changed.
                self.msgflowEvent('play-restart:request', {
                    id: msg.from,
                    screen: !!msg.screen,
                    reason: 'received request'
                });
                self.restartVideoPlay(!msg.screen ? msg.from : self.getScreenshareIdFromAttendantId(msg.from));
            } else if (msg.type == 'request-key-frame') {
                // a receiver wants to refresh our video.
                self.onVFITriggered(null, { isScreenShare: !!msg.screen, collate: msg.collate });
            } else if (msg.type == 'restart-video-publish') {
                // a receiver wants to refresh our video. TODO: this is a risk.
                self.onRestartVideoPublish(undefined, msg.screen);
            } else if (msg.type == 'orientationchange') {
                // mobile device orientation changed, but 'resize' event may not be triggered - ANYMO-729.
                self.onVideoOrientationChange(msg.from);
            } else if (msg.type == 'update-videos-layout') {
                // in layoutLock mode received the updated layout
                // TODO: check if msg.from is host or not.
                self.onUpdateVideosLayout(msg.data);
            } else if (msg.type == 'fetch-videos-layout') {
                // a non-host attendee wants to get the layout from host attendee. respond with update-videos-layout
                self.onFetchVideosLayout(msg.from);
            } else if (msg.type == 'force-audio-muted') {
                self.onForceAudioMuted(msg.from);
            } else if (msg.type == 'force-video-muted') {
                self.onForceVideoMuted(msg.from, msg.screen);
            } else if (msg.type == 'remote-console-request') {
                self.onRemoteConsoleRequest(msg);
            } else if (msg.type == 'remote-console-response') {
                self.onRemoteConsoleResponse(msg);
            } else if (msg.type == 'reconnect-sip') {
                // should check from host only TODO:
                self.onDoReconnectSIP();
            } else if (msg.type == 'reconnect-ws') {
                // should check from host only TODO:
                self.onDoReconnectWS();
            } else {
                logService.log('videoroomCtrl - ignoring attendee-message type=' + msg.type);
            }
        }

        function onAttendeeListUpdated(evt, data) {
            //logService.log('videoroomCtrl on attendee list updated');
            if (
                !data ||
                !data.propName ||
                (data.propName !== 'isTalking' &&
                    data.propName !== 'qualityBars' &&
                    data.propName !== 'showQualityBars')
            ) {
                self.syncAttendeeListVideoMuteStates();
            }
            if (self.talkerLayout) {
                self.updateTalkerLayout();
            }
            if (self.mediapath === 'sfu') {
                self.onMediaPathCheckTalkerActivity();
            }

            // update compact mode avatars on attendee list change
            if (self.isCompactMode && data && data.displayCount) {
                self.compactOnAttendeeListChange();
            }

            if (self.isCompactMode && data && !helperService.isDefaultAvatarUrl(data.imageURL)) {
                self.compactOnAttendeeListChange(data);
            }
        }

        // send restart-video-play to all attendees. If is_screen is true, then this is for screen share.
        function sendRestartVideoPlay(is_screen) {
            var list = attendeeListService.getAttendeeList();
            if (list) {
                list.forEach(function (attendee) {
                    if (attendee) {
                        if (attendee.attendantId != self.attendantId) {
                            logService.log('videoroomCtrl sending restart-video-play to ' + attendee.attendantId);
                            socketService.send({
                                message: 'attendee-message',
                                data: { type: 'restart-video-play', to: attendee.attendantId, screen: is_screen }
                            });
                        }
                    }
                });
            }
        }

        function onFSConnectionComplete() {
            connectivityService.setVertoConnected(true);
            connectivityService.setFSMemberConnected(true);

            if (connectivityService.getConferenceConnected()) {
                self.showConnectedOverlay();
            }
        }

        function isAttendeeVideoMuted(attendee) {
            return self.layoutPage && self.layoutPageData.playOnConnect
                ? attendee.isVideoMuted ||
                      attendee.isPhoneUser ||
                      (attendee.connectivity &&
                          ((attendee.connectivity.iceConnectionState !== 'connected' &&
                              attendee.connectivity.iceConnectionState !== 'completed') ||
                              attendee.connectivity.fsState !== 'connected' ||
                              attendee.connectivity.socketState !== 'connected'))
                : attendee.isVideoMuted;
        }

        function syncAttendeeListVideoMuteInternal(starts, stops, leaves, changes) {
            var list = attendeeListService.getAttendeeList();

            var found = {};

            if (list) {
                list.forEach(function (attendee) {
                    if (attendee) {
                        if (attendee.attendantId != self.attendantId) {
                            //logService.log('videoroomCtrl syncAttendeeListVideoMuteStates member ' + attendee.attendantId + ' video muted=' + attendee.isVideoMuted + ' video exist=' + !!self.feeds[attendee.attendantId]);
                            found[attendee.attendantId] = true;
                            if (self.mediapath == 'sfu') {
                                // if does not exist then start, otherwise enable or disable the video element.
                                if (!self.feeds[attendee.attendantId]) {
                                    starts.push({ id: attendee.attendantId, enabled: !attendee.isVideoMuted });
                                } else {
                                    var div = self.getVideoElement(attendee.attendantId, true);
                                    if (div && attendee.isVideoMuted && !$window.$(div).hasClass('audioonly')) {
                                        changes.push({ id: attendee.attendantId, enabled: false });
                                    } else if (div && !attendee.isVideoMuted && $window.$(div).hasClass('audioonly')) {
                                        changes.push({ id: attendee.attendantId, enabled: true });
                                    }
                                }
                            } else {
                                if (!self.isAttendeeVideoMuted(attendee) && !self.feeds[attendee.attendantId]) {
                                    starts.push({ id: attendee.attendantId, enabled: true });
                                } else if (attendee.isVideoMuted && self.feeds[attendee.attendantId]) {
                                    stops.push({ id: attendee.attendantId });
                                }
                            }

                            if (self.multishare) {
                                // if hasScreenVideo changed for an attendee, add/remove that video play box.
                                var attendantId = attendee.attendantId;
                                if (typeof attendantId === 'string' && attendantId.match(/^\d+$/)) {
                                    attendantId = parseInt(attendantId);
                                }
                                var screenshareId = self.getScreenshareIdFromAttendantId(attendantId);
                                if (attendee.attendantId != self.screenshareOwner) {
                                    if (attendee.hasScreenVideo && !self.feeds[screenshareId]) {
                                        starts.push({ id: attendee.attendantId, screen: true });
                                    } else if (!attendee.hasScreenVideo && self.feeds[screenshareId]) {
                                        stops.push({ id: attendee.attendantId, screen: true });
                                    }
                                }
                            }
                        }
                    }
                });
            }

            // if attendee list no longer has the item, remove the video feed too.
            for (var attendantId in self.feeds) {
                if (
                    !self.isScreenshareId(attendantId) &&
                    found[attendantId] === undefined &&
                    self.testvideosShouldStopVideoPlay(attendantId)
                ) {
                    logService.log('videoroomCtrl stopping video feed as attendee removed ' + attendantId);
                    leaves.push({ id: attendantId });
                }
            }
        }

        function syncAttendeeListVideoMuteStates() {
            if (self.onLayoutPage && self.onLayoutPageDelayAttendeeListSync()) {
                return;
            }

            self.stopResyncAfterNoSuchFeedTimer();

            var starts = [],
                stops = [],
                leaves = [],
                changes = []; // collect id to start, stop or change.

            self.syncAttendeeListVideoMuteInternal(starts, stops, leaves, changes);

            var sendMsgflowEvent = function (type, list) {
                if (self.mediapath != 'sfu') {
                    var filtered = list
                        .filter(function (data) {
                            return !data.screen;
                        })
                        .map(function (data) {
                            return data.id;
                        });
                    self.msgflowEvent(type + (filtered.length == 1 ? ':' + filtered[0] : ''), { id: filtered });
                }
            };

            if (self.layoutPage && starts.length > 0) {
                // do not start if recent missing feed.
                starts = self.onLayoutPageDelayMissingFeed(starts);
            }

            if (starts.length > 0) {
                if (self.janus && self.janus.isConnected()) {
                    sendMsgflowEvent('play-start:sync', starts);
                    starts.forEach(function (data) {
                        self.startVideoPlay(data.id, data.screen, data.enabled);
                    });
                } else {
                    logService.log('videoroomCtrl videoroom subscriber postponing attach plugin as not yet connected');
                }
            }
            if (stops.length > 0) {
                sendMsgflowEvent('play-stop:sync', stops);
                stops.forEach(function (data) {
                    self.stopVideoPlay(data.id, data.screen, false);
                });
            }
            if (changes.length > 0) {
                changes.forEach(function (data) {
                    self.enableVideoElement(data.id, data.enabled);
                });
            }
            if (leaves.length > 0) {
                sendMsgflowEvent('play-stop:left', leaves);
                leaves.forEach(function (data) {
                    self.stopVideoPlay(data.id, undefined, false);
                });
            }
        }

        function addPinToRequest(requestObj) {
            var pin = configService.getSfuPayload().videoRoomPin;
            if (requestObj && pin !== undefined && pin !== -1) {
                requestObj.pin = pin;
            }
        }

        function setPhoneOnlyState() {
            connectivityService.setPhoneOnlyState();
            // fake it as completed, instead of disconnected, so that it does not show spinning icon in attendee list.
            connectivityService.sendIceConnStateToServer('completed', self.getJanusConnectionState());
        }

        function getIceTransportPolicy() {
            return self.iceTransportPolicy == 'relay' ||
                (self.iceTransportOnTCP > 0 && self.iceDisconnectedCount >= self.iceTransportOnTCP - 1)
                ? 'relay'
                : 'all';
        }

        function getIceServers() {
            var iceServers = connectivityService.getIceServers();

            if (iceServers && self.iceTransportOnTCP > 0 && self.iceDisconnectedCount >= self.iceTransportOnTCP - 1) {
                logService.log('videoroomCtrl - getIceServers - filter only TCP 443 TURN');
                var urlRegExp = /:443\?transport=tcp\b/;
                iceServers = iceServers
                    .map(function (item) {
                        if (typeof item.urls === 'object' && item.urls.length !== undefined) {
                            var urls = item.urls.filter(function (value) {
                                return value.match(urlRegExp);
                            });
                            return Object.assign({}, item, { urls: urls });
                        } else {
                            return item;
                        }
                    })
                    .filter(function (item) {
                        if (typeof item.urls === 'string') {
                            return item.urls.match(urlRegExp);
                        } else if (typeof item.urls === 'object' && item.urls.length !== undefined) {
                            return item.urls.length > 0;
                        } else {
                            return false;
                        }
                    });
            }

            return iceServers;
        }
    }
]);
